var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app"},[_c('div',{staticClass:"son1 sn1"}),_c('div',{staticClass:"son1 sn2"}),_c('div',{staticClass:"son1 sn3"},[_vm._v("李晓菲是🐷")])])])
}]

export { render, staticRenderFns }